import axios from "axios";
import { useEffect, useState } from "react";
import { FaFilePdf } from "react-icons/fa";
import { API_URL } from "../../url/api";
import { AssessmentData } from "../DoctorsPages/AssessmentReportUpload";

interface Therapy {
  id: number;
  assesment_report: string;
  assesment_date: string;
  is_assesment_submitted: boolean;
  assesment_pdf_url: string;
  updated_at: string;
  created_at: string;
  doctor: number;
  session: number;
  user: number;
}

const TherapyTable = ({ therapies }: { therapies: Therapy[] }) => {
  const userId = localStorage.getItem("userId");

  const [assessmentData, setAssementData] = useState<AssessmentData[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get<AssessmentData[]>(
        `${API_URL}assessment/?user=${userId}`
      );
      console.log("🚀 ~ fetchData ~ doctorID:", response);
      setAssementData(response.data);
    } catch (error) {
      console.error("Error fetching appointment data:", error);
    }
  };

  return (
    <div className="overflow-x-auto">
      {/* <div className="mb-4">
        <label htmlFor="filterType" className="mr-2">
          Filter by Assessment Report:
        </label>
        <select
          id="filterType"
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          className="border border-gray-300 rounded-md px-2 py-1"
        >
          <option value="">All</option>
          {therapyTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
      </div> */}

      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              {/* <th scope="col" className="px-6 py-3 text-nowrap">
                Assessment Report
              </th> */}
              <th scope="col" className="px-6 py-3 text-nowrap">
                Assessment Date
              </th>
              <th scope="col" className="px-6 py-3 text-nowrap">
                Submitted
              </th>
              <th scope="col" className="px-6 py-3 text-nowrap">
                Assessment PDF
              </th>
            </tr>
          </thead>
          <tbody>
            {assessmentData.map((assesment) => (
              <tr
                key={assesment.id}
                className="odd:bg-white even:bg-gray-50 border-b"
              >
                <td className="px-6 py-4">
                  {new Date(assesment.created_at).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </td>
                <td className="px-6 py-4">
                  {assesment.assessment_pdf_url !== "" ? "Yes" : "No"}
                </td>
                <td className="px-6 py-4">
                  <a
                    href={assesment.assessment_pdf_url}
                    download
                    className="flex items-center text-blue-500 hover:text-blue-600"
                  >
                    <FaFilePdf className="mr-2" />
                    <span>Download</span>
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const AssessmentResults = () => {
  const [therapies, setTherapies] = useState<Therapy[]>([]);

  useEffect(() => {
    const fetchAssessments = async () => {
      try {
        const userId = localStorage.getItem("userId") || "1";
        const response = await axios.get<Therapy[]>(
          `${API_URL}assessment/?user=${userId}`
        );
        setTherapies(response.data);
      } catch (error) {
        console.error("Error fetching assessments:", error);
      }
    };

    fetchAssessments();
  }, []);

  return (
    <div className="container mx-auto p-4 md:p-8">
      <h1 className="text-3xl font-bold mb-6">Assessments</h1>
      <TherapyTable therapies={therapies} />
    </div>
  );
};

export default AssessmentResults;
